import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Header } from 'semantic-ui-react';
import FileStore from '../../../app/stores/fileStore';

interface IProps {
  setFiles: (files: object[]) => void;
}

const dropzoneStyles = {
  textAlign: 'center' as 'center',
};

const dropzoneActive = {
  borderColor: 'green'
};

const AssetPhotoDropzone: React.FC<IProps> = ({ setFiles }) => {

  const onDrop = useCallback(acceptedFiles => {
    setFiles(
      acceptedFiles.map((file: object) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file)
        })
      )
    );
  }, [setFiles]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: 'image/jpeg, image/png' });

  return (
    <div
      {...getRootProps()}
      style={
        isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
      }
    >
      <input {...getInputProps()} />
      Photo
    </div>
  );
};

export default AssetPhotoDropzone;
